import effectManager from '../effect';

let _effect = new effectManager();

export default class panelManager {

    constructor(){

        this.panelFull = $("#c-changepanel__square-full");
        this.panelHalf = $("#c-changepanel__square-half");
        this.nowWidth = '';
        this.nextWidth = '';

    }

    /* -----------------------------------------------

     -- hide

     -------------------------------------------------- */

    hide(_status,_scroll) {

        let _this = this;

        if(_scroll.nowID === 'l-development' || _scroll.nowID === 'l-developer' || _scroll.nowID === 'l-contact'){
            _this.nowWidth = 'full';
        }else if(_scroll.nowID === 'l-main-copy'){
            _this.nowWidth = false;
        }else{
            _this.nowWidth = 'half';
        }

        if(_scroll.nextID === 'l-development' || _scroll.nextID === 'l-developer' || _scroll.nextID === 'l-contact'){
            _this.nextWidth = 'full';
        }else if(_scroll.nextID === 'l-main-copy'){
            _this.nextWidth = false;
        }else{
            _this.nextWidth = 'half';
        }

        // set
        TweenMax.to(_scroll.section.filter('.js__current'), .45, {
            autoAlpha: 0,
            display: 'none',
            easing: Expo.easeOut
        });
        _scroll.section.filter('.js__current').removeClass("js__current");

        //motion
        if(Useragnt.mobile){
            _this.show(_status,_scroll);
        }else{
            if (_status.panelShow === true && _this.nowWidth !== _this.nextWidth) {

                $('.js__panel-square').removeClass("is-done");

                if (_this.nowWidth === 'full') {
                    _effect.panelMove(_this.panelFull.children(), '100%', 'hide');
                    setTimeout(function () {
                        _this.show(_status,_scroll);
                    }, 1300);
                } else if (_this.nowWidth === 'half') {
                    _effect.panelMove(_this.panelHalf.children(), '-100%', 'hide');
                    setTimeout(function () {
                        _this.show(_status,_scroll);
                    }, 900);
                }else {
                    _this.show(_status,_scroll);
                }
            } else {
                _this.show(_status,_scroll);
            }
        }

    }

    /* -----------------------------------------------

     -- show

     -------------------------------------------------- */

    show(_status,_scroll) {

        let _this = this;

        if(_scroll.nowID === 'l-development' || _scroll.nowID === 'l-developer' || _scroll.nowID === 'l-contact'){
            _this.nowWidth = 'full';
        }else if(_scroll.nowID === 'l-main-copy'){
            _this.nowWidth = false;
        }else{
            _this.nowWidth = 'half';
        }

        if(_scroll.nextID === 'l-development' || _scroll.nextID === 'l-developer' || _scroll.nextID === 'l-contact'){
            _this.nextWidth = 'full';
        }else if(_scroll.nextID === 'l-main-copy'){
            _this.nextWidth = false;
        }else{
            _this.nextWidth = 'half';
        }

        if(Useragnt.mobile){
            _scroll.show(_status);
        }else{
            // set
            if (_this.nowWidth !== _this.nextWidth) {
                $(".js__panel-square").removeAttr('style');
                TweenLite.set($(".js__panel-square>*"), {y: '100%', opacity: 0});
            }

            //motion
            if (_this.nextWidth === 'full') {
                _effect.panelMove(_this.panelFull.children(), '0%', 'show');
                setTimeout(function () {
                    _scroll.show(_status);
                    _status.panelShow = true;
                }, 1300);
            } else if (_this.nextWidth === 'half') {
                _effect.panelMove(_this.panelHalf.children(), '0%', 'show');
                setTimeout(function () {
                    _scroll.show(_status);
                    _status.panelShow = true;
                }, 900);
            } else {
                _scroll.show(_status);
                _status.panelShow = false;
            }
        }

    }

}
